/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LlmConfigurationDeleteTriggerResponseIdDelete$Params {
  id: number;
}

export function llmConfigurationDeleteTriggerResponseIdDelete(http: HttpClient, rootUrl: string, params: LlmConfigurationDeleteTriggerResponseIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, llmConfigurationDeleteTriggerResponseIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

llmConfigurationDeleteTriggerResponseIdDelete.PATH = '/LLMConfiguration/DeleteTriggerResponse/{id}';
